/* eslint-disable @typescript-eslint/no-explicit-any */
// The whole code is copied from VPC.

/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import * as _ from 'underscore';
import { BodyCell } from '@tableau/widgets-datagrid';
import { cssClass, textEllipsis } from '../../../../common/styles/CommonStyles';
import { L10n } from '../../../../common/utils/L10n';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { SizeFilter } from '../../../../common/utils/SizeFilter';

export function PlainTextCell(propertyName: string, testId?: string, styleOverride?: React.CSSProperties): React.Factory<BodyCell.Props> {
  return StyledCellFormatter(
    React.createFactory(function PlainTextCell(props: BodyCell.Props) {
      const text = props.row.data[propertyName];
      return (
        <span title={text} data-tb-test-id={testId}>
          {text}
        </span>
      );
    }),
    styleOverride
  );
}

export function PlainTextCellWithTransform(
  propertyName: string,
  transform: (value: any) => string,
  testId?: string,
  styleOverride?: React.CSSProperties
): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    React.createFactory(function PlainTextCellWithTransform(props: BodyCell.Props) {
      const text = transform(props.row.data[propertyName]);
      return (
        <span title={text} data-tb-test-id={testId}>
          {text}
        </span>
      );
    }),
    styleOverride
  );
}

const dataGridCellText = cssClass('plainTextCellWithCount-text', textEllipsis, {
  display: 'block',
});

export function CreateCellText(text: string): JSX.Element {
  return (
    <span data-tb-test-id="data-grid-cell-text" className={dataGridCellText} title={text}>
      {text}
    </span>
  );
}

/* export function PlainTextCellWithCount(
  text: string,
  getPopoverContent?: (props: BodyCell.Props) => Promise<JSX.Element>,
  count?: string,
  testId?: string
): React.StatelessComponent<BodyCell.Props> {
  return function PlainTextCellWithCount(props) {
    const getContent = () => getPopoverContent!(props);
    return (
      <CellWithCountAndToolTip count={count} testId={testId} getPopoverContent={getContent}>
        {CreateCellText(text)}
      </CellWithCountAndToolTip>
    );
  };
} */

export interface ITextWithIconSpecifiedByUrl {
  text: string;
  title?: string;
  textStyle?: React.CSSProperties;
  iconTitle?: string;
  iconUrl: string;
  hideTooltips?: boolean;
}

export interface ITextWithIconSpecifiedByClassWithBackgroundImage {
  text: string;
  title?: string;
  textStyle?: React.CSSProperties;
  iconTitle?: string;
  iconClass: string;
  hideTooltips?: boolean;
}

export interface PlainTextCellWithIconAndCountProps extends BodyCell.Props {
  metadataFn: (rowData: any) => ITextWithIconSpecifiedByUrl;
  getPopoverContent?: (props: BodyCell.Props) => Promise<JSX.Element>;
  count?: string;
  testId?: string;
}

export function LocalizedCountCell(property: string | ((item: any) => number | undefined), testId?: string): React.Factory<BodyCell.Props> {
  return React.createFactory(function LocalizedCountCell(props: BodyCell.Props) {
    let count;
    if (property instanceof Function) {
      count = property(props.row.data);
    } else {
      count = props.row.data[property];
    }
    const localizedCount = L10n.localizedCount(count);
    return (
      <span style={{ padding: '0 12px' }} data-tb-test-id={testId}>
        {_.isNumber(count) ? localizedCount : ''}
      </span>
    );
  });
}

export function SizeCell(propertyName: string | ((item: any) => number | undefined), testId?: string): React.Factory<BodyCell.Props> {
  return React.createFactory(function SizeCell(props: BodyCell.Props) {
    let sizeInBytes;
    if (propertyName instanceof Function) {
      sizeInBytes = propertyName(props.row.data);
    } else {
      sizeInBytes = props.row.data[propertyName];
    }
    return <span data-tb-test-id={testId}>{SizeFilter(sizeInBytes)}</span>;
  });
}
